import { Component, Input } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { Order } from 'src/app/core/orders.service';
import { QineticPosition, QineticPositionService } from 'src/app/core/qinetic-position.service';

@Component({
  selector: 'app-order-details-qinetic-docs',
  templateUrl: './order-details-qinetic-docs.component.html',
  styleUrls: ['./order-details-qinetic-docs.component.scss'],
})
export class OrderDetailsQineticDocsComponent {
  @Input() order?: Order;

  is_read_running = false;
  qinetic_position?: QineticPosition;

  constructor(private qinetic_position_service: QineticPositionService, private error_service: ErrorService) {}

  ngOnInit(): void {
    const qinetic_position_id = this.order?.qinetic_position_id;
    const buyer_id = this.order?.buyer_id;
    if (qinetic_position_id && buyer_id) this.readQineticPosition(qinetic_position_id, buyer_id);
  }

  readQineticPosition(qinetic_position_id: string, buyer_id: string): void {
    this.is_read_running = true;
    this.qinetic_position_service.read(qinetic_position_id, buyer_id).subscribe({
      next: response => {
        this.qinetic_position = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.qinetic_position = undefined;
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }
}
